<template>
  <q-page padding class=" window-width row justify-center">
    <div class="col-12 col-sm-8">
      <q-form @submit.prevent.stop="changePassword">
        <q-card>
          <q-toolbar class="bg-primary text-white">
            <q-toolbar-title>Сброс пароля</q-toolbar-title>
          </q-toolbar>
          <q-card-section class="q-gutter-md">
            <q-input v-model="changePasswordRequest.password" :rules="[requiredRule, passwordRule]" dense square outlined
                     type="password" label="Пароль"/>
          </q-card-section>
          <q-card-actions>
            <q-btn
                no-caps
                type="submit"
                color="primary"
                label="Изменить"
                class=" form-button"
            />
          </q-card-actions>
        </q-card>
      </q-form>

    </div>
  </q-page>

</template>

<script setup lang="ts">
import {reactive} from "vue"
import {useChangePassword} from "../composables/auth";
import {requiredRule,passwordRule} from "../util/rules"
import {useQuasar} from "quasar";
import {ChangePasswordRequest} from "../models/auth";
import {useRoute} from "vue-router"

const route = useRoute()
const changePasswordRequest: ChangePasswordRequest = reactive({
  code: route.params.code as string,
  username: route.query.username as string,
  password: ""
})

const $q = useQuasar()
const {execute} = useChangePassword(changePasswordRequest)

async function changePassword() {
  await execute(true)
  $q.dialog({
    message: "Пароль сменен",
    ok: {
      to: "/login",
      flat: true
    },
    cancel: false,
    persistent: true
  })
}
</script>

<style scoped>

</style>